import React from 'react';
import PlaceholderTab from './PlaceholderTab';

function ExceptionReviewTab() {
  return <PlaceholderTab tabName="Exception Review" />;
}

export default ExceptionReviewTab;
